/**
 * Application configuration.
 *
 * Defaults defined here can be overridden at runtime by setting
 * window.smpReactAppSettings before the React app mounts
 * (e.g. via a <script> tag in public/index.html).
 */

const runtimeSettings = window.smpReactAppSettings || {};

const config = {
  // API & AWS
  apiPath:
    runtimeSettings.apiPath ||
    'https://g2xbq6s7p8.execute-api.ap-south-1.amazonaws.com/default/face-search',

  lowResPath:
    runtimeSettings.lowResPath ||
    'https://showmypics.s3.ap-south-1.amazonaws.com/aid2026/low-res/',

  highResPath:
    runtimeSettings.highResPath ||
    'https://showmypics.s3.ap-south-1.amazonaws.com/aid2026/high-res/',

  photosApiBaseUrl:
    runtimeSettings.photosApiBaseUrl ||
    'https://photo-search.orangeideas.in',

  collectionId:
    runtimeSettings.collectionId ||
    'aid2026',

  // App metadata & branding
  appTitle:
    runtimeSettings.appTitle ||
    'Advantage Vidarbha 2026 Photos',

  productName:
    runtimeSettings.productName ||
    'ShowMy.Pics',

  companyName:
    runtimeSettings.companyName ||
    'Peenak',

  companyUrl:
    runtimeSettings.companyUrl ||
    'https://peenak.com',

  supportEmail:
    runtimeSettings.supportEmail ||
    'hello@peenak.com',

  // UI constants
  imageCompressionQuality:
    runtimeSettings.imageCompressionQuality || 0.3,

  masonryBreakpoints:
    runtimeSettings.masonryBreakpoints || {
      default: 4,
      1100: 3,
      700: 2,
      500: 1,
    },

  lightboxZoomStep:
    runtimeSettings.lightboxZoomStep || 0.3,

  lightboxDoubleClickZoom:
    runtimeSettings.lightboxDoubleClickZoom || 4,

  allowedFileTypes:
    runtimeSettings.allowedFileTypes || ['image/jpeg', 'image/png'],

  placeholderImageUrl:
    runtimeSettings.placeholderImageUrl ||
    'https://via.placeholder.com/400x400?text=Image+Failed+to+Load',

  // Feature flags (use ?? for booleans to handle false correctly)
  useHighQuality:
    runtimeSettings.useHQ ?? runtimeSettings.useHighQuality ?? false,
};

export default config;
